





















import { Vue,Component, Prop } from "vue-property-decorator";

import Speaker from "../../program/components/Speaker.vue";
import UserInfoPopupSpeaker from "./UserInfoPopupSpeaker.vue"
import { UserProfile } from "../../../api/models/UserProfile";

@Component({
    components: { Speaker, UserInfoPopupSpeaker }
})
export default class UserInfoPopup extends Vue {
    @Prop({required: true}) user: UserProfile;
    @Prop({default: false}) showPopup: boolean;
    @Prop({required: false}) tailOffset?: number;
    @Prop({default: 32}) userIconSize: number;

    defaultIconSize = 38;

    elementEventHandler(event: Event) {
        event.stopPropagation();
    }

    get tailOfftetStyle() {
        return {
            left: this.tailOffset + 'px'
        }
    }
}
